import { useTranslation } from 'react-i18next';

import { Language } from '../../../locale/constants';

export const useLanguage = () => {
    const {
        i18n: { language },
    } = useTranslation();

    return { language, isEng: language === Language.en };
};
